<template>
    <div class='ToastList text-left'>
        <Toast v-for='toast in toasts' 
        :key='toasts.id' 
        :toast='toast'
        />
    </div>
</template>

<script>
    import Toast from './Toast';
    export default{
        name: 'ToastList',
        components: {
            Toast
        },
        computed:{
            toasts(){
                return this.$store.getters['Navigation/activeToasts']
            }
        }
    }
</script>